import React from 'react';
import Helmet from 'react-helmet';
import { useIntl } from 'react-intl';

import messages from 'messages';
import { getProductName } from 'utils';

const ListHelmet: React.FC = () => {
    const { formatMessage } = useIntl();

    const helmetTitle =
        window.__app.initialTitle ||
        formatMessage(messages.matchListPageTitle, {
            productName: getProductName(),
        });

    return <Helmet title={helmetTitle} />;
};

export default React.memo(ListHelmet);
